import * as _ from 'lodash';
import { TraceEvents } from './call-trace-event';
import { byName } from './call-trace-selectors/util';
import { selectStartDelay } from './call-trace-selectors/select-start-delay';
export class CallTrace {
    constructor(person, logger) {
        this.person = person;
        this.logger = logger;
        this.events = [];
        this.track(TraceEvents.Init);
    }
    static eventNameToTimerAction(name) {
        switch (name) {
            case TraceEvents.SessionCreated:
            case TraceEvents.ConnectionCreated:
            case TraceEvents.ParticipantAppeared:
                return 'step';
            case TraceEvents.ParticipantVideoAppeared:
                return 'finish';
            default:
                return null;
        }
    }
    logToDataDog(event) {
        const alreadySeenEvent = this.events.filter(byName(event.name)).length > 1;
        if (alreadySeenEvent) {
            return;
        }
        const timerAction = CallTrace.eventNameToTimerAction(event.name);
        if (timerAction === 'step' || timerAction === 'finish') {
            this.logger.info(timerAction, {
                step: event.name,
                duration: 1000000 * event.delay,
            });
        }
        if (timerAction === 'finish') {
            const startDelay = selectStartDelay(this.events, event.name);
            this.logger.info('total', {
                duration: 1000000 * startDelay,
            });
        }
    }
    track(name, data) {
        const timestamp = Date.now();
        const lastEvent = this.getLastEvent();
        const delay = lastEvent ? timestamp - lastEvent.timestamp : 0;
        const event = {
            name,
            timestamp,
            data,
            delay,
        };
        this.events.push(event);
        this.logToDataDog(event);
    }
    isActive() {
        return !_.some(this.events, (e) => [TraceEvents.End].includes(e.name));
    }
    getLastEvent() {
        return this.events[this.events.length - 1];
    }
}
